(function () {
  var SECTION_SELECTOR = '.oddit-section-card-grid';

  function initSection(section) {
    if (!section || section.dataset.odditInit === 'true') return;
    section.dataset.odditInit = 'true';

    var grid = section.querySelector('.oddit-section-card-grid__grid');
    var progress = section.querySelector('.oddit-section-card-grid__progress');
    var thumb = section.querySelector('.oddit-section-card-grid__progress-thumb');

    if (!grid || !progress || !thumb) return;

    var minWidthPct = 15;

    function updateProgress() {
      var maxScroll = grid.scrollWidth - grid.clientWidth;
      var ratio = maxScroll > 0 ? grid.scrollLeft / maxScroll : 0;
      if (ratio < 0) ratio = 0;
      if (ratio > 1) ratio = 1;

      var widthPct = minWidthPct + (100 - minWidthPct) * ratio;
      thumb.style.width = widthPct + '%';
    }

    grid.addEventListener('scroll', updateProgress, { passive: true });

    var ro = null;
    var usingResizeObserver = typeof ResizeObserver !== 'undefined';
    if (usingResizeObserver) {
      ro = new ResizeObserver(updateProgress);
      ro.observe(grid);
      ro.observe(progress);
    } else {
      window.addEventListener('resize', updateProgress);
    }

    // Store cleanup handle on the section for shopify:section:unload
    section._odditCleanup = function () {
      grid.removeEventListener('scroll', updateProgress);
      if (ro) {
        ro.disconnect();
        ro = null;
      } else {
        window.removeEventListener('resize', updateProgress);
      }
      delete section.dataset.odditInit;
    };

    // Initial paint
    requestAnimationFrame(updateProgress);
  }

  function destroySection(section) {
    if (!section) return;
    if (typeof section._odditCleanup === 'function') {
      section._odditCleanup();
      section._odditCleanup = null;
    }
  }

  function initAll() {
    var sections = document.querySelectorAll(SECTION_SELECTOR);
    for (var i = 0; i < sections.length; i++) {
      initSection(sections[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) destroySection(section);
  });
})();
